import { Mark, mergeAttributes } from "@tiptap/core";

export type VariableLinkAttributes = {
  variable: string | null;
};

export type VariableLinkOptions = {
  HTMLAttributes: Record<string, unknown>;
};

/**
 * Links a prose phrase to a math variable by its symbol. Color and hover
 * emphasis are painted by an editor-side decoration plugin, never here.
 */
export const VariableLink = Mark.create<VariableLinkOptions>({
  name: "variableLink",

  inclusive: false,

  addOptions() {
    return {
      HTMLAttributes: {
        class: "variable-link",
      },
    };
  },

  addAttributes() {
    return {
      variable: {
        default: null,
        parseHTML(element) {
          return element.getAttribute("data-variable-link");
        },
        renderHTML({ variable }: VariableLinkAttributes) {
          if (!variable) {
            return null;
          }

          return {
            "data-variable-link": variable,
          };
        },
      },
    };
  },

  parseHTML() {
    // textStyle also parses bare spans; win the tie and leave the element
    // available so both marks survive a copy/paste round-trip.
    return [{ tag: "span[data-variable-link]", priority: 60, consuming: false }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["span", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
});
